export const logo =
  "https://assets.nflxext.com/ffe/siteui/vlv3/e393bb3f-261f-43d1-99bb-16a157885615/web/TJ-ru-20260105-TRIFECTA-perspective_fa6ece3f-a5be-4ce0-a137-3d863457a489_large.jpg";

export const API_OPTIONS = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJlYTBmZjMyMzdhZGJkNjRhYjRiNGI3YzliZWVlZjFmZCIsIm5iZiI6MTc2ODM4NTI3MS4xODksInN1YiI6IjY5Njc2YWY3OTk1NTkxMzMyMzQ4N2E3YSIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.EGniZ8gjuTKd0vpvikx7u6WmEr1hDOalQpj5xRINtVU",
  },
};

export const IMG_CON_URL = "https://image.tmdb.org/t/p/w500"





